import _typeof from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import customerServiceApi from '@/api/customer-service';
import customerServiceSignalR from '@/utils/customer-service-signalr';
export default {
  name: 'CustomerServicePanel',
  props: {
    agent: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      sessions: [],
      selectedSession: null,
      messages: [],
      replyText: '',
      transcribingMessageId: '',
      playingAudioMessageId: '',
      audioPlayer: null,
      activeQuickReplyCategory: 'common',
      quickReplyCategories: [],
      fallbackQuickReplyCategories: [{
        key: 'common',
        name: '常用',
        replies: [{
          id: 'fallback-common-1',
          title: '帮您看看',
          content: '好的，我帮您看一下。'
        }, {
          id: 'fallback-common-2',
          title: '稍等核实',
          content: '请您稍等，我这边核实后回复您。'
        }, {
          id: 'fallback-common-3',
          title: '留下联系方式',
          content: '方便留下您的联系方式吗？我们会尽快联系您。'
        }]
      }, {
        key: 'admission',
        name: '招生咨询',
        replies: [{
          id: 'fallback-admission-1',
          title: '咨询专业',
          content: '可以的，您想了解哪个专业的招生信息？'
        }, {
          id: 'fallback-admission-2',
          title: '报名流程',
          content: '报名流程一般包括咨询、提交资料、审核和确认几个步骤。'
        }, {
          id: 'fallback-admission-3',
          title: '意向专业',
          content: '您可以告诉我您的学历情况和意向专业，我帮您进一步说明。'
        }]
      }, {
        key: 'fee',
        name: '学费住宿',
        replies: [{
          id: 'fallback-fee-1',
          title: '学费说明',
          content: '学费会根据专业不同有所差异，您想咨询哪个专业？'
        }, {
          id: 'fallback-fee-2',
          title: '住宿安排',
          content: '住宿安排通常以学校当年公布的标准为准。'
        }, {
          id: 'fallback-fee-3',
          title: '费用明细',
          content: '费用明细我可以按您关注的专业帮您整理说明。'
        }]
      }],
      bound: false
    };
  },
  computed: {
    activeQuickReplies: function activeQuickReplies() {
      var _this = this;
      var category = this.quickReplyCategories.find(function (item) {
        return item.key === _this.activeQuickReplyCategory;
      });
      return category ? category.replies : [];
    }
  },
  watch: {
    active: {
      immediate: true,
      handler: function handler(value) {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!value) {
                  _context.n = 1;
                  break;
                }
                _context.n = 1;
                return _this2.bootstrap();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }))();
      }
    },
    agent: {
      handler: function handler() {
        var _this3 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!_this3.active) {
                  _context2.n = 1;
                  break;
                }
                _context2.n = 1;
                return _this3.bootstrap();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }))();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAudioPlayback();
    this.unbindSignalREvents();
  },
  methods: {
    bootstrap: function bootstrap() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (_this4.agent) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return customerServiceSignalR.init(_this4.agent.id);
            case 2:
              _this4.bindSignalREvents();
              _context3.n = 3;
              return _this4.loadQuickReplies();
            case 3:
              _context3.n = 4;
              return _this4.loadSessions();
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    loadQuickReplies: function loadQuickReplies() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$Promise$all, _yield$Promise$all2, categoryData, templateData, categories, templates, groupedCategories, _this5$quickReplyCate, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return Promise.all([customerServiceApi.methods.getReplyTemplateCategories.call(_this5, {
                enabledOnly: true,
                availableOnly: true
              }), customerServiceApi.methods.getReplyTemplates.call(_this5, {
                page: 1,
                size: 200,
                enabledOnly: true,
                availableOnly: true
              })]);
            case 1:
              _yield$Promise$all = _context4.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              categoryData = _yield$Promise$all2[0].data;
              templateData = _yield$Promise$all2[1].data;
              categories = categoryData || [];
              templates = (templateData === null || templateData === void 0 ? void 0 : templateData.list) || [];
              groupedCategories = categories.map(function (category) {
                return {
                  key: String(category.id),
                  name: category.categoryName,
                  replies: templates.filter(function (template) {
                    return template.categoryId === category.id;
                  })
                };
              }).filter(function (category) {
                return category.replies.length;
              });
              _this5.quickReplyCategories = groupedCategories.length ? groupedCategories : _this5.fallbackQuickReplyCategories;
              if (!_this5.quickReplyCategories.some(function (category) {
                return category.key === _this5.activeQuickReplyCategory;
              })) {
                _this5.activeQuickReplyCategory = ((_this5$quickReplyCate = _this5.quickReplyCategories[0]) === null || _this5$quickReplyCate === void 0 ? void 0 : _this5$quickReplyCate.key) || 'common';
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t = _context4.v;
              _this5.quickReplyCategories = _this5.fallbackQuickReplyCategories;
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }))();
    },
    loadSessions: function loadSessions() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$customerServic, data, fresh;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (_this6.agent) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.n = 2;
              return customerServiceApi.methods.getActiveSessions.call(_this6);
            case 2:
              _yield$customerServic = _context5.v;
              data = _yield$customerServic.data;
              _this6.sessions = _this6.sortSessions(data || []);
              if (_this6.selectedSession) {
                fresh = _this6.sessions.find(function (x) {
                  return x.sessionId === _this6.selectedSession.sessionId;
                });
                _this6.selectedSession = fresh || null;
              }
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    selectSession: function selectSession(session) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$customerServic2, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this7.stopAudioPlayback();
              _this7.selectedSession = session;
              _context6.n = 1;
              return customerServiceApi.methods.getMessages.call(_this7, session.sessionId, 1, 100);
            case 1:
              _yield$customerServic2 = _context6.v;
              data = _yield$customerServic2.data;
              _this7.messages = data || [];
              _context6.n = 2;
              return _this7.markSelectedSessionRead();
            case 2:
              _this7.$nextTick(_this7.scrollToBottom);
            case 3:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    sendReply: function sendReply() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var content;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!(!_this8.replyText.trim() || !_this8.selectedSession || !_this8.agent)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              content = _this8.replyText.trim();
              _context7.n = 2;
              return customerServiceSignalR.invoke('SendAgentMessage', _this8.selectedSession.sessionId, content, _this8.agent.id);
            case 2:
              _this8.replyText = '';
              _context7.n = 3;
              return _this8.selectSession(_this8.selectedSession);
            case 3:
              _context7.n = 4;
              return _this8.loadSessions();
            case 4:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    transcribeAudio: function transcribeAudio(message) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var resp, updated, _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!(!message.messageId || _this9.transcribingMessageId)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              _this9.transcribingMessageId = message.messageId;
              _context8.p = 2;
              _context8.n = 3;
              return customerServiceApi.methods.transcribeAudioMessage.call(_this9, message.messageId);
            case 3:
              resp = _context8.v;
              updated = resp && resp.data ? resp.data : resp;
              _this9.messages = _this9.messages.map(function (item) {
                return item.messageId === message.messageId ? _objectSpread(_objectSpread({}, item), updated) : item;
              });
              _context8.n = 5;
              break;
            case 4:
              _context8.p = 4;
              _t2 = _context8.v;
              _this9.$message.error('语音转文字失败');
            case 5:
              _context8.p = 5;
              _this9.transcribingMessageId = '';
              return _context8.f(5);
            case 6:
              return _context8.a(2);
          }
        }, _callee8, null, [[2, 4, 5, 6]]);
      }))();
    },
    triggerAudioConvert: function triggerAudioConvert(message) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var resp, updated, _t3;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (message.messageId) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, null);
            case 1:
              _context9.p = 1;
              _context9.n = 2;
              return customerServiceApi.methods.convertAudioMessage.call(_this0, message.messageId);
            case 2:
              resp = _context9.v;
              updated = resp && resp.data ? resp.data : resp;
              if (!(updated && updated.messageId)) {
                _context9.n = 3;
                break;
              }
              _this0.messages = _this0.messages.map(function (item) {
                return item.messageId === message.messageId ? _objectSpread(_objectSpread({}, item), updated) : item;
              });
              return _context9.a(2, updated);
            case 3:
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t3 = _context9.v;
            case 5:
              return _context9.a(2, null);
          }
        }, _callee9, null, [[1, 4]]);
      }))();
    },
    toggleAudioPlayback: function toggleAudioPlayback(message) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var attachment, player;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              attachment = _this1.getAudioAttachment(message);
              if (attachment.url) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              if (!attachment.playUrl) {
                _this1.triggerAudioConvert(message);
              }
              if (!(_this1.playingAudioMessageId === message.messageId && _this1.audioPlayer)) {
                _context0.n = 2;
                break;
              }
              _this1.stopAudioPlayback();
              return _context0.a(2);
            case 2:
              _this1.stopAudioPlayback();
              player = new Audio(attachment.url);
              _this1.audioPlayer = player;
              _this1.playingAudioMessageId = message.messageId;
              player.onended = function () {
                if (_this1.audioPlayer === player) {
                  _this1.stopAudioPlayback();
                }
              };
              player.onerror = function () {
                if (_this1.audioPlayer === player) {
                  _this1.$message.error('语音播放失败');
                  _this1.stopAudioPlayback();
                }
              };
              player.play().catch(function () {
                _this1.$message.error('语音播放失败');
                _this1.stopAudioPlayback();
              });
            case 3:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    stopAudioPlayback: function stopAudioPlayback() {
      if (this.audioPlayer) {
        this.audioPlayer.pause();
        this.audioPlayer.onended = null;
        this.audioPlayer.onerror = null;
        this.audioPlayer = null;
      }
      this.playingAudioMessageId = '';
    },
    handleReplyKeydown: function handleReplyKeydown(event) {
      if (event.key !== 'Enter') return;
      if (event.ctrlKey) {
        event.preventDefault();
        this.insertTextAtCursor('\n');
        return;
      }
      event.preventDefault();
      this.sendReply();
    },
    insertQuickReply: function insertQuickReply(template) {
      var content = template.content || template;
      var prefix = this.replyText && !this.replyText.endsWith('\n') ? '\n' : '';
      this.replyText = "".concat(this.replyText).concat(prefix).concat(content);
      if (template.id && !String(template.id).startsWith('fallback-')) {
        customerServiceApi.methods.useReplyTemplate.call(this, template.id).catch(function () {});
      }
    },
    insertTextAtCursor: function insertTextAtCursor(text) {
      var textarea = this.$el.querySelector('.cs-reply-box textarea');
      if (!textarea) {
        this.replyText += text;
        return;
      }
      var start = textarea.selectionStart;
      var end = textarea.selectionEnd;
      this.replyText = "".concat(this.replyText.slice(0, start)).concat(text).concat(this.replyText.slice(end));
      this.$nextTick(function () {
        textarea.focus();
        var position = start + text.length;
        textarea.setSelectionRange(position, position);
      });
    },
    endCurrentSession: function endCurrentSession() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (_this10.selectedSession) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              _this10.stopAudioPlayback();
              _context1.n = 2;
              return customerServiceSignalR.invoke('EndSession', _this10.selectedSession.sessionId);
            case 2:
              _this10.selectedSession = null;
              _this10.messages = [];
              _context1.n = 3;
              return _this10.loadSessions();
            case 3:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    bindSignalREvents: function bindSignalREvents() {
      if (this.bound) return;
      customerServiceSignalR.on('ReceiveCustomerMessage', this.handleIncomingMessage);
      customerServiceSignalR.on('ReceiveMessage', this.handleIncomingMessage);
      customerServiceSignalR.on('SessionEnded', this.handleSessionEnded);
      this.bound = true;
    },
    unbindSignalREvents: function unbindSignalREvents() {
      customerServiceSignalR.off('ReceiveCustomerMessage', this.handleIncomingMessage);
      customerServiceSignalR.off('ReceiveMessage', this.handleIncomingMessage);
      customerServiceSignalR.off('SessionEnded', this.handleSessionEnded);
      this.bound = false;
    },
    handleIncomingMessage: function handleIncomingMessage(message) {
      var session = this.sessions.find(function (x) {
        return x.sessionId === message.sessionId;
      });
      var isSelectedSession = this.selectedSession && this.selectedSession.sessionId === message.sessionId;
      if (session) {
        session.lastMessage = message.content;
        session.lastMessageTime = message.createdTime;
        if (Number(message.senderType) === 1 && !isSelectedSession) {
          session.unreadCount = (session.unreadCount || 0) + 1;
        }
        this.sessions = this.sortSessions(this.sessions);
      } else {
        this.loadSessions();
      }
      if (isSelectedSession) {
        if (!this.messages.some(function (item) {
          return item.messageId && item.messageId === message.messageId;
        })) {
          this.messages.push(message);
        }
        if (Number(message.senderType) === 1 && message.messageId) {
          this.markMessagesRead([message.messageId]);
        }
        this.$nextTick(this.scrollToBottom);
      }
    },
    handleSessionEnded: function handleSessionEnded() {
      this.loadSessions();
    },
    sortSessions: function sortSessions(sessions) {
      var _this11 = this;
      return _toConsumableArray(sessions).sort(function (a, b) {
        return _this11.getSortTime(b) - _this11.getSortTime(a);
      });
    },
    getSortTime: function getSortTime(session) {
      var time = session.lastMessageTime || session.updatedTime || session.createdTime;
      var value = time ? new Date(time).getTime() : 0;
      return Number.isFinite(value) ? value : 0;
    },
    scrollToBottom: function scrollToBottom() {
      var el = this.$refs.messageList;
      if (el) el.scrollTop = el.scrollHeight;
    },
    markSelectedSessionRead: function markSelectedSessionRead() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var unreadIds;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (_this12.selectedSession) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              unreadIds = _this12.messages.filter(function (message) {
                return Number(message.senderType) === 1 && !message.isRead && message.messageId;
              }).map(function (message) {
                return message.messageId;
              });
              if (!unreadIds.length) {
                _context10.n = 3;
                break;
              }
              _context10.n = 2;
              return _this12.markMessagesRead(unreadIds);
            case 2:
              _context10.n = 4;
              break;
            case 3:
              _this12.setSessionUnreadCount(_this12.selectedSession.sessionId, 0);
            case 4:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    markMessagesRead: function markMessagesRead(messageIds) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (messageIds.length) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              _context11.n = 2;
              return customerServiceApi.methods.markMessagesAsRead.call(_this13, messageIds);
            case 2:
              _this13.messages = _this13.messages.map(function (message) {
                if (messageIds.includes(message.messageId)) {
                  return _objectSpread(_objectSpread({}, message), {}, {
                    isRead: true
                  });
                }
                return message;
              });
              if (_this13.selectedSession) {
                _this13.setSessionUnreadCount(_this13.selectedSession.sessionId, 0);
              }
            case 3:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    setSessionUnreadCount: function setSessionUnreadCount(sessionId, count) {
      this.sessions = this.sessions.map(function (session) {
        if (session.sessionId === sessionId) {
          return _objectSpread(_objectSpread({}, session), {}, {
            unreadCount: count
          });
        }
        return session;
      });
      if (this.selectedSession && this.selectedSession.sessionId === sessionId) {
        this.selectedSession = _objectSpread(_objectSpread({}, this.selectedSession), {}, {
          unreadCount: count
        });
      }
    },
    formatSessionId: function formatSessionId(sessionId) {
      if (!sessionId) return '';
      return sessionId.length > 12 ? sessionId.slice(-12) : sessionId;
    },
    formatTime: function formatTime(time) {
      if (!time) return '';
      var date = new Date(time);
      var diff = Date.now() - date.getTime();
      if (diff < 60000) return '刚刚';
      if (diff < 3600000) return "".concat(Math.floor(diff / 60000), "\u5206\u949F\u524D");
      if (diff < 86400000) return "".concat(Math.floor(diff / 3600000), "\u5C0F\u65F6\u524D");
      return date.toLocaleDateString();
    },
    getSenderName: function getSenderName(senderType) {
      var names = {
        1: '客户',
        2: '智能客服',
        3: '客服',
        4: '系统'
      };
      return names[Number(senderType)] || '消息';
    },
    getSessionStatusText: function getSessionStatusText(status) {
      var texts = {
        1: 'AI对话',
        2: '人工接入',
        3: '已结束',
        4: '客户离线'
      };
      return texts[Number(status)] || '会话中';
    },
    getMessageClass: function getMessageClass(senderType) {
      if (Number(senderType) === 4) return 'system';
      return Number(senderType) === 3 ? 'agent' : 'visitor';
    },
    getAvatarText: function getAvatarText(text) {
      return String(text || '?').slice(0, 1);
    },
    getMessageAvatar: function getMessageAvatar(message) {
      var _this$agent;
      var senderType = Number(message.senderType);
      if (senderType === 1) return '客';
      if (senderType === 2) return 'AI';
      if (senderType === 3) return this.getAvatarText(message.senderName || ((_this$agent = this.agent) === null || _this$agent === void 0 ? void 0 : _this$agent.agentName) || '我');
      return '系';
    },
    isAudioMessage: function isAudioMessage(message) {
      return Number(message.contentType || message.ContentType) === 4;
    },
    getAudioAttachment: function getAudioAttachment(message) {
      var raw = message.attachments || message.Attachments;
      if (!raw) return {};
      if (_typeof(raw) === 'object') return this.normalizeAudioAttachment(raw);
      try {
        return this.normalizeAudioAttachment(JSON.parse(raw));
      } catch (error) {
        return {};
      }
    },
    normalizeAudioAttachment: function normalizeAudioAttachment(attachment) {
      if (!attachment || _typeof(attachment) !== 'object') return {};
      return {
        url: attachment.playUrl || attachment.PlayUrl || attachment.url || attachment.Url || '',
        playUrl: attachment.playUrl || attachment.PlayUrl || '',
        objectKey: attachment.objectKey || attachment.ObjectKey || '',
        duration: attachment.duration || attachment.Duration || 0,
        size: attachment.size || attachment.Size || 0,
        mimeType: attachment.mimeType || attachment.MimeType || '',
        fileName: attachment.fileName || attachment.FileName || ''
      };
    },
    getAudioDurationText: function getAudioDurationText(message) {
      var attachment = this.getAudioAttachment(message);
      var duration = Number(message.audioDurationSeconds || attachment.duration || 0);
      return duration > 0 ? "".concat(duration, " \u79D2") : '语音消息';
    },
    canTranscribeAudio: function canTranscribeAudio(message) {
      var status = Number(message.transcriptStatus || 0);
      return this.isAudioMessage(message) && status !== 2 && status !== 3;
    },
    getTranscriptStatusText: function getTranscriptStatusText(message) {
      var status = Number(message.transcriptStatus || 0);
      if (status === 2) return '识别中';
      if (status === 3) return '已转文字';
      if (status === 4) return '识别失败';
      return '待识别';
    }
  }
};